import en_us from './messages/en-US.json';
import { setLocaleCookie } from '../../utilities.js';

const locales = (
  state = {
    active: 'en',
    defaultLocale: 'en',
    messages: {
      en: en_us,
    },
  },
  action
) => {
  switch (action.type) {
    case 'ADD_MESSAGES_FOR_LOCALE':
      return {
        ...state,
        messages: {
          ...state.messages,
          [action.locale]: action.messages,
        },
      };
    case 'CHANGE_LOCALE':
      setLocaleCookie(action.locale);
      return {
        ...state,
        active: action.locale,
      };
    default:
      return state;
  }
};

export default locales;

export const getMessageProps = (state, id) => {
  return {
    id,
    defaultMessage: state.messages.en[id],
  };
};

export const messageIdExists = (state, id) => id in state.messages.en;
const getMessageIdsByModelAndType = (state, id, type) => {
  // 1. Find the matching keys
  const keys = Object.keys(state.messages.en).filter(key => {
    const r = RegExp(`model.${id}.${type}`);
    return r.test(key);
  });
  // 2. Sort the keys, since they end in '.<n>'
  keys.sort((a, b) => {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  });
  return keys;
};

export const getObjectiveMessageIdsByModel = (state, id) =>
  getMessageIdsByModelAndType(state, id, 'objectives');
export const getQuestionMessageIdsByModel = (state, id) =>
  getMessageIdsByModelAndType(state, id, 'questions');
